import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import Stack from '@zenbusiness/zui/Stack';

import { QACard } from '../components/QACard';
import { SectionGrid } from '../components/SectionGrid';
import { WebinarCard } from '../components/WebinarCard';
import { WebinarDialog } from '../components/WebinarDialog';
import { WEBINAR_LOCALIZED_TEXT } from '../constants';
import { getWebinarProps, getQAProps } from '../helpers';
import useWebinarDialog from '../hooks/useWebinarDialog';

function RunningAndGrowing({ webinars, qaSection }) {
  const { formatMessage: fm } = useIntl();

  const {
    webinar: selectedWebinar,
    onClose: handleCloseDialog,
    isOpen: isDialogOpen
  } = useWebinarDialog(webinars);

  return (
    <Stack gap={{ xs: 3, md: 4 }}>

      <SectionGrid title={WEBINAR_LOCALIZED_TEXT.sections.webinars}>
        {webinars.map((webinar) => (
          <WebinarCard key={webinar.id} {...getWebinarProps(webinar, fm)} />
        ))}
      </SectionGrid>

      <SectionGrid title={WEBINAR_LOCALIZED_TEXT.sections.joinOurQA}>
        {qaSection.map((item) => (
          <QACard key={item.id} {...getQAProps(item, fm)} />
        ))}
      </SectionGrid>

      { isDialogOpen && (
        <WebinarDialog
          title={fm({ id: selectedWebinar.titleKey })}
          videoId={selectedWebinar.videoId}
          onClose={handleCloseDialog}
        />
      )}
    </Stack>
  );
}

const webinarShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  titleKey: PropTypes.string.isRequired,
  descriptionKey: PropTypes.string.isRequired,
  imagePath: PropTypes.string.isRequired,
  mobileImagePath: PropTypes.string,
  businessPhase: PropTypes.string.isRequired,
  videoId: PropTypes.string,
  externalUrl: PropTypes.string,
  isFeatured: PropTypes.bool.isRequired
});

const qaShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  titleKey: PropTypes.string.isRequired,
  externalUrl: PropTypes.string,
  scheduleKey: PropTypes.string.isRequired
});

RunningAndGrowing.propTypes = {
  qaSection: PropTypes.arrayOf(qaShape),
  webinars: PropTypes.arrayOf(webinarShape)
};

export default RunningAndGrowing;
